import React, { lazy } from "react";
import { useParams } from "react-router-dom";

const InstagramCaptionGenerator = lazy(() => import("./Pages/InstagramCaptionGenerator"));
const FacebookCaptionGenerator = lazy(() => import("./Pages/FacebookCaptionGenerator"));
const TikTokCaptionGenerator = lazy(() => import("./Pages/TikTokCaptionGenerator"));
const PinterestCaptionGenerator = lazy(() => import("./Pages/PinterestCaptionGenerator"));
const SocialMediaCaptionGenerator = lazy(() => import("./Pages/SocialMediaCaptionGenerator"));

export default function CaptionGenerator() {
  let { slug } = useParams();
  //let CaptionComponent;

  switch (slug) {
    case "instagram":
      return <InstagramCaptionGenerator />;
    case "facebook":
      return <FacebookCaptionGenerator />;
    case "tiktok":
      return <TikTokCaptionGenerator />;
    case "pinterest":
      return <PinterestCaptionGenerator />;
    case "social-media":
      return <SocialMediaCaptionGenerator />;

    default:
      return null;
  }
}
